import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'

import SelectBox from './SelectBox'

@inject((store: any) => {
    const { categoriesStore } = store
    return {
        categoriesStore
    }
})
@observer
export default class CategorySelect extends Component<any> {
    changeCategory = value => {
        this.props.categoryChanged(value)
    }
    render() {
        const { styles, disabled, categoriesStore } = this.props

        let categoriesSelects

        const { selectedCategories, indexedParents, indexedCategories } = categoriesStore
        const lastChild = selectedCategories.length > 0 ? selectedCategories[selectedCategories.length - 1] : null

        categoriesSelects = (
            <Fragment>
                {selectedCategories.map((selectedCategory, index) => {
                    const categoryLevel = selectedCategory['parent_id']
                        ? selectedCategory['parent_id']
                        : 'main_category'

                    return (
                        <SelectBox
                            disabled={disabled}
                            key={`${index}_select`}
                            styles={styles ? styles : ''}
                            selectedCategory={selectedCategory ? selectedCategory : undefined}
                            value={selectedCategory['id'] ? selectedCategory['id'] : null}
                            categoryLevels={indexedParents}
                            categoryLevel={categoryLevel}
                            categoryChanged={value => this.changeCategory(value)}
                            title={
                                !selectedCategory['parent_id']
                                    ? 'קטגוריה ראשית'
                                    : `תת קטגוריה בתחום ${indexedCategories[selectedCategory['parent_id']]['name']}`
                            }
                        />
                    )
                })}
                {lastChild && indexedParents[lastChild.id] ? (
                    <SelectBox
                        disabled={disabled}
                        key={lastChild.id}
                        styles={styles}
                        selectedCategory={null}
                        categoryLevels={indexedParents}
                        categoryLevel={lastChild.id}
                        title={`תת קטגוריה בתחום ${lastChild['name']}`}
                        categoryChanged={value => this.changeCategory(value)}
                    />
                ) : (
                    ''
                )}
            </Fragment>
        )

        return <Fragment>{categoriesSelects}</Fragment>
    }
}
